(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-mybets-wager/assets/react/components/ongoing-wager-summary.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-mybets-wager/assets/react/components/ongoing-wager-summary.js');

'use strict';

const formatCurrency = svs.utils.format.Currency;
const {
  FormatTime
} = svs.utils.date;
const {
  DRAWS
} = svs.lyckoplatsen.components.shared_constants.CONSTANTS;
const OngoingWagerSummary = _ref => {
  let {
    wager
  } = _ref;
  const geoBoardData = wager.wager.bets[0].geoBoardData;
  const charity = wager.wagerCharity;
  const {
    totalDrawCount,
    addonTotalDrawCount,
    properties: {
      channel
    },
    regWagerTime,
    betAmount,
    completedDraws,
    lastDrawDate,
    wagerId,
    isSubscription
  } = wager;
  const {
    latitude,
    longitude
  } = geoBoardData.geoLoc;
  const locationName = geoBoardData.geoLocName;
  const allTotalDrawCount = totalDrawCount + addonTotalDrawCount;
  const drawsCount = completedDraws.length + 1;
  const Bold = _ref2 => {
    let {
      children
    } = _ref2;
    return React.createElement("span", {
      className: "f-bold"
    }, children);
  };
  const isCustomerSupport = svs.core.userSession.hasRole(svs.core.userSession.roles.CUSTOMERSERVICE);
  return React.createElement("div", {
    className: "wager-summary",
    "data-wager-id": wager.wagerId
  }, React.createElement("div", {
    className: "wager-summary-content"
  }, React.createElement("div", {
    className: "wager-summary-header"
  }, locationName), React.createElement("div", {
    className: "wager-summary-row"
  }, React.createElement("div", {
    className: "wager-summary-cell"
  }, React.createElement(Bold, null, "Betalt:"), " ", React.createElement("span", null, FormatTime("d/M', kl. 'HH:mm", regWagerTime)))), React.createElement("div", {
    className: "wager-summary-row"
  }, React.createElement("div", {
    className: "wager-summary-cell"
  }, React.createElement(Bold, null, "Insats:"), " ", React.createElement("span", null, formatCurrency(betAmount), " kr"))), (totalDrawCount > DRAWS.DRAWS_PER_WEEK || isSubscription) && React.createElement("div", {
    className: "wager-summary-row"
  }, React.createElement("div", {
    className: "wager-summary-cell"
  }, React.createElement(Bold, null, "Insats per vecka:"), " ", React.createElement("span", null, isSubscription ? formatCurrency(parseInt(betAmount, 10)) : formatCurrency(parseInt(betAmount, 10) / DRAWS.NUMBER_OF_WEEKS), " kr"))), latitude && longitude && React.createElement("div", {
    className: "wager-summary-row"
  }, React.createElement("div", {
    className: "wager-summary-cell"
  }, React.createElement(Bold, null, "Koordinater:"), " ", latitude, '\u00b0', "N - ", longitude, '\u00b0', "E")), charity && React.createElement("div", {
    className: "wager-summary-row"
  }, React.createElement("div", {
    className: "wager-summary-cell"
  }, React.createElement(Bold, null, "Bidrar till:"), " ", charity.name)), !isSubscription && React.createElement("div", {
    className: "wager-summary-row"
  }, React.createElement("div", {
    className: "wager-summary-cell border-right"
  }, React.createElement(Bold, null, "Dragning:"), " ", React.createElement("span", null, drawsCount, " av ", allTotalDrawCount)), React.createElement("div", {
    className: "wager-summary-cell"
  }, React.createElement(Bold, null, "P\xE5g\xE5r t.o.m.:"), " ", FormatTime('d/M', lastDrawDate))), React.createElement("div", {
    className: "wager-summary-row"
  }, React.createElement("div", {
    className: "wager-summary-cell bg-grey-200"
  }, React.createElement(Bold, null, "Spelat via:"), " ", React.createElement("span", {
    className: "f-capitalize"
  }, isSubscription ? 'Prenumeration' : channel))), isCustomerSupport && React.createElement("div", {
    className: "wager-summary-row"
  }, React.createElement("div", {
    className: "wager-summary-cell"
  }, React.createElement(Bold, null, "Wager ID:"), " ", wagerId))));
};
setGlobal('svs.lyckoplatsen.components.shared_mybets_wager.react.components', {
  OngoingWagerSummary
});

 })(window);